import { Component, OnInit,Inject, OnDestroy } from '@angular/core';
import { ShipyardService } from '../shipyard.service';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HeaderService } from 'src/app/components/header/header.service';
import { Subject, takeUntil } from 'rxjs';
import { CreateShipmentPopupComponent } from 'src/app/components/create-shipment-popup/create-shipment-popup.component';

@Component({
  selector: 'app-related-shipment-popup',
  templateUrl: './related-shipment-popup.component.html',
  styleUrls: ['./related-shipment-popup.component.scss']
})
export class RelatedShipmentPopupComponent implements OnInit, OnDestroy {
  relatedShipments:any[]=[]
  private destroy$ = new Subject<void>();
  account;
  hasErrorShipment:boolean=false;
  dialogRef1:any;
  actions:any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<RelatedShipmentPopupComponent>,
    private shipyardService:ShipyardService,
    private snackBar:MatSnackBar,
    private headerService:HeaderService,
    private dialog:MatDialog
    ) {
      this.headerService.accountsSelected
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
        this.account = e;
      });
     }

  ngOnInit(): void {
    this.loadShipment();
  }
  
  loadShipment(){
    this.shipyardService.GetRelatedShipment(this.data.shipmentId,this.account).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        this.relatedShipments=res
        this.hasErrorShipment= res.find(res=> !res.isSuccess);
      },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 5000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    )}
   });
  }

  openOnAmazon(shipment) {
    window.open(
      `https://sellercentral.amazon.com/fba/inbound-shipment/summary/${shipment.amazonShipmentId}`,
      "_blank"
    );
  }

  openDialog(shipment){
    this.dialog.open(CreateShipmentPopupComponent, {
      width: "650px",
      data:shipment,
    }).afterClosed()
    .subscribe(() => {});
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
